import Api from "services/Api";
import _ from 'lodash';
import store from 'store/index';

/**
 * Mutation Types
 *
 * @type {Object}
 */
const mutationTypes = {
};

/**
 * State.
 *
 * @type {Object}
 */
const state = {

};

/**
 * Getters.
 *
 * @type {Object}
 */
const getters = {
};

/**
 * Actions.
 *
 * @type {Object}
 */
const actions = {
    /**
     * Send email to support.
     *
     * @param {dispatch}
     * @param {state}
     */
    sendMail: _.debounce((noop, {claim, query}) => {
        if (query !== '') {
            return Api.support.sendEmail({claim, query, userId: store.getters['user/getUserId']}).then((data) => {
                return data.sent;
            });
        }
    }, 500),
};

/**
 * Mutations
 *
 * @type {Object}
 */
const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/support/index.js